import { InjectionToken } from '@angular/core';

/**
 * Base URL of the portal surface on es-world-api — provided once at app
 * bootstrap as `${environment.apiUrl}/portal` (the world BFF mounts each
 * surface under `/api/<surface>` via RouterModule). Feature services prepend
 * it to relative resource paths (`/islands`, `/ecms/contents`,
 * `/companies/:orgId/members`, …) so they stay declaration-only and carry no
 * environment or surface-prefix knowledge.
 */
export const PORTAL_API_BASE_URL = new InjectionToken<string>('PORTAL_API_BASE_URL');
